<template>
	<div class="usuarios-container">
		<div class="header-users">
			<Card
				width="23%"
				title="Usuários"
				:hide-subtitle="true"
				subtitle="Por mês"
				:data="datacarduser"
			/>
			<Card width="23%" title="Ativos" subtitle="Por mês" :data="datacardactive" />
			<Card width="23%" title="Novos" subtitle="Por mês" :data="datacardnew" />
			<Card width="23%" title="Desativados" subtitle="Por mês" :data="datacarddisabled" />
		</div>
		<user-table
			:data="dados"
			:loadingtable="isloading"
			:current-page="currentpage"
			:rowsperpage="rowsperpage"
			:total="totalpages"
			@editaction="editperson($event)"
			@searchtext="filterTable($event)"
			@filtertable="
				filterTable({
					...$event,
					limit: rowsperpage,
					offset: currentpage * rowsperpage - rowsperpage,
					direction: 'desc',
					orderby: 'created_at',
				})
			"
			@page-change="pagechange($event)"
			@update-table="filterTable($event)"
			@change-order="filterTable($event)"
			@change-rows="filterTable($event)"
		/>
	</div>
</template>

<script>
import * as ecAxios from '@/util/ecAxios';
import moment from 'moment';
import Card from '../../layout/components/cards/carddata';
import userTable from '../../layout/components/table/usertable';

export default {
	components: {
		userTable,
		Card,
	},
	data() {
		return {
			interval: null,
			currentpage: 1,
			totalpages: 0,
			rowsperpage: 50,
			dados: [],
			searchTerm: '',
			isloading: true,
			datacarduser: {
				qt: 0,
				percent: '0%',
				percencolor: '#000',
				icon: {
					size: '28px',
					type: 'user-friends',
					bgColor: 'rgba(0,201,167,.1)',
					color: '#00c9a7',
				},
			},
			datacardactive: {
				qt: 0,
				percent: '0%',
				percencolor: '#000',
				icon: {
					size: '28px',
					type: 'poll',
					bgColor: 'rgba(0,201,167,.1)',
					color: '#22c03c',
				},
			},

			datacarddisabled: {
				qt: 0,
				percent: '-0%',
				percentcolor: '#000',
				icon: {
					size: '28px',
					type: 'user-clock',
					bgColor: 'rgba(237,76,120,.1)',
					color: '#ee335e',
				},
			},

			datacardnew: {
				qt: 0,
				percent: '-0%',
				percentcolor: '#000',
				icon: {
					size: '28px',
					type: 'user-plus',
					bgColor: 'rgba(237,76,120,.1)',
					color: '#7340cc',
				},
			},
		};
	},
	activated() {
		const offset = this.currentpage * this.rowsperpage - this.rowsperpage;
		let filterDate = {};
		if (localStorage.getItem('filter-users')) {
			filterDate = JSON.parse(localStorage.getItem('filter-users'));
		}
		this.filterTable({
			...filterDate,
			limit: this.rowsperpage,
			offset,
			direction: 'desc',
			orderby: 'created_at',
		});
	},
	created() {
		this.getCardsData();
	},
	methods: {
		pagechange(page) {
			this.currentpage = page.page;
			this.filterTable(page);
		},
		verifyIcon(inputData) {
			const down = '#ed4c78';
			const up = '#00c9a7';
			if (inputData < 0) {
				return down;
			}
			if (inputData >= 0) {
				return up;
			}
			return down;
		},
		async getCardsData() {
			const dtFinal = moment().format('YYYY-MM-DD k:mm:ss');
			const dtinicial = moment(dtFinal).subtract(2, 'months').format('YYYY-MM-DD k:mm:ss');
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.USERS_DETAILS}`, {
					dt_inicial: dtinicial,
					dt_final: dtFinal,
					interval: 2,
				})
				.then((response) => {
					if (response.status === 200) {
						const percentData = response.data.data;
						this.datacarduser.percent = `${percentData.toFixed(2)}%`;
						this.datacarduser.percentcolor = this.verifyIcon(percentData);
					}
				})
				.catch(() => {});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.USERS_DETAILS}`, {
					dt_inicial: dtinicial,
					dt_final: dtFinal,
					interval: 2,
					status: 1,
				})
				.then((response) => {
					if (response.status === 200) {
						const percentData = response.data.data;
						this.datacardactive.percent = `${percentData.toFixed(2)}%`;
						this.datacardactive.percentcolor = this.verifyIcon(percentData);
					}
				})
				.catch(() => {});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.USERS_DETAILS}`, {
					dt_inicial: dtinicial,
					dt_final: dtFinal,
					interval: 2,
				})
				.then((response) => {
					if (response.status === 200) {
						const percentData = response.data.data;
						this.datacardnew.qt = response.data.last_month;
						this.datacardnew.percent = `${percentData.toFixed(2)}%`;
						this.datacardnew.percentcolor = this.verifyIcon(percentData);
					}
				})
				.catch(() => {});

			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.USERS_DETAILS}`, {
					dt_inicial: dtinicial,
					dt_final: dtFinal,
					interval: 2,
					status: [0],
				})
				.then((response) => {
					if (response.status === 200) {
						const percentData = response.data.data;
						this.datacarddisabled.percent = `${percentData.toFixed(2)}%`;
						this.datacarddisabled.percentcolor = this.verifyIcon(percentData);
						this.datacarddisabled.qt = response.data.last_month;
					}
				})
				.catch(() => {});
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.TOTAL_USERS_COUNT}`, {
					status: 1,
				})
				.then((response) => {
					if (response.status === 200) {
						this.datacardactive.qt = response.data;
					}
				})
				.catch(() => {});
		},
		async filterTable(evt) {
			if (evt.rowsperpage) {
				this.rowsperpage = evt.rowsperpage;
			}
			if (evt.status === '2') {
				// eslint-disable-next-line no-param-reassign
				evt.status = null;
			}

			if (evt.interval) {
				this.interval = evt.interval;
			} else {
				this.interval = null;
			}
			if (evt.searchTerm && evt.searchTerm !== this.searchTerm) {
				this.searchTerm = evt.searchTerm;
			}
			if (evt.searchTerm === '') {
				this.searchTerm = '';
			}
			this.isloading = true;
			await ecAxios
				.connection()
				.post(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIOS}`, {
					offset: evt.offset ? evt.offset : 0,
					limit: evt.limit ? evt.limit : null,
					searchTerm: this.searchTerm,
					status: evt.status >= 0 ? evt.status : null,
					direction: evt.direction ? evt.direction : null,
					orderby: evt.orderby ? evt.orderby : null,
					interval: this.interval,
				})
				.then((response) => {
					if (response) {
						this.dados = response.data.usuarios;
						this.totalpages = response.data.count;
						this.datacarduser.qt = response.data.count;
						this.isloading = false;
					}
				})
				.catch((e) => {
					this.isloading = false;
					this.$buefy.notification.open({
						message: e.toString(),
						type: 'is-danger',
					});
				});
		},
		async editperson(dataselected) {
			if (dataselected.selected.status !== 0) {
				const { selected } = dataselected;
				selected.status = 0;
				await ecAxios
					.connection()
					.put(`${process.env.VUE_APP_API_ADM_EC}${api.env.EC_USUARIO}${selected.id}`, selected)
					.then((response) => {
						if (response.status === 200) {
							this.filterTable(dataselected);
						}
					})
					.catch((e) => {
						this.$buefy.notification.open({
							message: e.toString(),
							type: 'is-danger',
						});
					});
			}
		},
	},
};
</script>

<style scoped>
.header-users {
	display: flex;
	width: 100%;
	justify-content: space-between;
	margin-bottom: 50px;
}
</style>

